// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar--17ffa2bb","small":"small--561db1f3","medium":"medium--01b013f6","base":"base--85b99b63","fixedSpace":"fixedSpace--7acf556a"};